module.exports = __webpack_public_path__ + "img/BANDEAU_QUITTER.890ed303.svg";